<template>
  <div id="userLayout" class="user-layout-wrapper">
    <div class="container">
      <div class="logo"></div>
      <a-form id="formLogin" ref="formLogin" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input
            class="login-input"
            size="large"
            type="text"
            placeholder="请输入帐号"
            v-decorator="[
              'account',
              { rules: [{ required: true, message: '请输入帐号' }], validateTrigger: 'change' }
            ]"
          >
            <div slot="prefix" class="account-icon" />
          </a-input>
        </a-form-item>

        <!-- 密码 -->
        <a-form-item>
          <a-input
            class="login-input"
            size="large"
            type="password"
            autocomplete="false"
            placeholder="请输入密码"
            v-decorator="['password', { rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur' }]"
          >
            <div slot="prefix" class="passage-icon" />
          </a-input>
        </a-form-item>
        <div style="color: #000c17">如果忘记密码，请联系您的业务经理</div>

        <!-- 确定 -->
        <a-form-item style="margin:30px 0 50px;">
          <a-button
            size="large"
            type="primary"
            htmlType="submit"
            class="login-button"
            :loading="state.loginBtn"
            :disabled="state.loginBtn"
          >登&nbsp;&nbsp;录</a-button>
        </a-form-item>
      </a-form>

    </div>
  </div>
</template>

<script>
import { mixinDevice } from '@/utils/mixin'
import _ from 'lodash'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'

export default {
  name: 'UserLayout',
  mixins: [mixinDevice],
  components: {},
  data() {
    return {
      loginBtn: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false
      },
      codeTimestamp: ''
    }
  },
  mounted () {
    document.body.classList.add('userLayout')
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  },
  created() {},
  methods: {
    refreshCode() {
      this.codeTimestamp = new Date().getTime()
    },
    ...mapActions(['Login', 'Logout']),
    handleSubmit(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        Login
      } = this

      state.loginBtn = true

      const validateFieldsKey = ['tenantCode', 'account', 'password', 'captcha']

      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          const params = {
            tenantCode: values.tenantCode,
            account: values.account,
            code: values.captcha,
            password: values.password
          }
          Login(params)
            .then((res) => {
              if (_.get(res, 'code') === 200) {
                this.loginSuccess(res)
              }
            })
            .catch((err) => console.log(err))
            .finally(() => {
              state.loginBtn = false
            })
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    loginSuccess(res) {
      const paramArr = window.location.search
      const index = paramArr.indexOf('path')
      const id = paramArr.substr(4, index - 5)
      const path = paramArr.substr(index + 5).replace(/%2F/g, '/')
      this.$router.push({ path: path, query: { id: id } })
      // this.$router.go(-1)
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
    },
    requestFailed(err) {
      this.$notification['error']({
        message: '错误',
        description: err.message || '请求出现错误，请稍后再试',
        duration: 4
      })
    }
  }
}
</script>

<style lang="less">
body{
  background-color: #fff !important;
  input{
    background-color: #F2F2F2 !important;
    color: #777 !important;
    border-radius: 2rem !important;
    border: 1px solid #d2d2d2 !important;
  }
}
#userLayout {
  background:#fff url(../../assets/images/mobile-login-bg.png) no-repeat center center;
  background-size: cover;
}
#userLayout.user-layout-wrapper {
  height: 100%;
  .container {
    width: 100%;
    min-height: 100%;
    background-size: 100%;
    padding-top: 8rem;
    position: relative;
    //display: flex;
    //align-items: center;
    justify-content: center;
  }
}
.logo{
  //width: 100%;
  width: 6rem;
  height: 7.25rem;
  //height: 30rem;
  background-image: url('../../assets/images/mobile-logo.png');
  background-size: 100% 100%;
  margin: 0 auto 50px;
}
button.login-button {
  font-size: 20px;
  height: 40px;
  width: 100%;
  background: #27C6A0;
  border-radius: 20px;
  margin-top: 10%;
  color: #F2F2F2;
}
/deep/.ant-input-affix-wrapper .ant-input {
  text-align: center;
  border: none;
  border-radius: 20px;
  overflow: hidden;
  background-color: #F2F2F2;
  background-clip: content-box;
  color: #27c6a0;
  padding: 0
}
#formLogin{
  width: 80%;
  margin-left: 10%;
}
</style>
